import React from 'react';

/** Balance-scale icon for Compare product (matches storefront reference). */
const CompareScaleIcon = ({ className = '', size = 16 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M7 20h10" />
    <path d="M12 5v15" />
    <path d="M5 5h14" />
    <path d="M5 5v1.5" />
    <path d="M4 11.5L5 6.5L6 11.5" />
    <path d="M4 11.5h2" />
    <path d="M19 5v1.5" />
    <path d="M18 11.5l1-5 1 5" />
    <path d="M18 11.5h2" />
  </svg>
);

export default CompareScaleIcon;
